export default "__VITE_ASSET__DpF2y5Fi__"